import { firstDayOfWeekFallback, timeFormatFallback } from '.'
export const API_ROOT = window.__env.API_ROOT
export const SOCKET_SERVER = window.__env.SOCKET_SERVER
export const BASE_URL = window.__env.BASE_URL
export const URL_COOKIES_POLICY = window.__env.URL_COOKIES_POLICY
export const URL_PRIVACY_POLICY = window.__env.URL_PRIVACY_POLICY
export const APP_SERVICE_ID = window.__env.APP_SERVICE_ID
export const APP_FACILITY_ID = window.__env.APP_FACILITY_ID
export const COOKIE_MODAL_ID = window.__env.COOKIE_MODAL_ID
export const SUCCESS_COLOR = window.__env.SUCCESS_COLOR
export const WARNING_COLOR = window.__env.WARNING_COLOR
export const INFO_COLOR = window.__env.INFO_COLOR
export const ERROR_COLOR = window.__env.ERROR_COLOR
export const SUCCESS_TEXT_COLOR = window.__env.SUCCESS_TEXT_COLOR
export const WARNING_TEXT_COLOR = window.__env.WARNING_TEXT_COLOR
export const INFO_TEXT_COLOR = window.__env.INFO_TEXT_COLOR
export const ERROR_TEXT_COLOR = window.__env.ERROR_TEXT_COLOR
export const FONT_FAMILY_NAME = window.__env.FONT_FAMILY_NAME
export const TIME_FORMAT = window.__env.TIME_FORMAT || timeFormatFallback
export const FIRST_DAY_OF_WEEK = window.__env.FIRST_DAY_OF_WEEK || firstDayOfWeekFallback
export const URL_PDF_VIEWER = window.__env.URL_PDF_VIEWER
export const PAYMENT_ATTEMPTS =  window.__env.PAYMENT_ATTEMPTS || 10
